import { extend } from "vee-validate";
import {
  required,
  min_value,
  max_value,
  ext,
  max,
  min,
  numeric,
} from "vee-validate/dist/rules";

const telefoneComDDDValidator = {
  validate(value: string) {
    const digits = (value || "").replace(/\D+/g, "");
    const regex = /^(55)?([1-9]{2})(\d{4,5})(\d{4})$/;
    return regex.test(digits);
  }
};

extend("required", {
  ...required,
  message: "Este campo é obrigatório",
});

extend("min_value", {
  ...min_value,
  message: `Valor não permitido`,
});

extend("max_value", {
  ...max_value,
  message: `Valor não permitido`,
});

extend("ext", {
  ...ext,
  message: `Extensão inválida`,
});

extend("max", {
  ...max,
  message: (fieldName, p1) => {
    return `São permitidos ${p1.length} caracteres. O limite foi excedido em ${p1._value_.length - p1.length
      } caractere(s).`;
  },
});

extend("min", {
  ...min,
  message: (fieldName, p1) => {
    return `Mínimo de ${p1.length} caracteres.`;
  },
});

extend("numeric", {
  ...numeric,
  message: `Valores numéricos apenas.`,
});

extend("telefoneComDDD", {
  ...telefoneComDDDValidator,
  message: `Não é um telefone válido (com DDD)`
})
